// ช่วงวันที่สำเร็จรูปสำหรับหน้ารายงาน — คืนค่าเป็น [start, end] ของ Date
// ที่ตัดเวลาทิ้งแล้ว (เที่ยงคืนตามปฏิทินท้องถิ่น) ให้ผู้เรียกเอาไป format เอง

const startOfDay = date => new Date(date.getFullYear(), date.getMonth(), date.getDate())

const addDays = (date, days) => {
  const d = startOfDay(date)
  d.setDate(d.getDate() + days)
  return d
}

const daysInMonth = (year, month) => new Date(year, month + 1, 0).getDate()

// setMonth ตรง ๆ ล้นเดือน เช่น 31 พ.ค. ถอย 3 เดือนได้ 31 ก.พ. ที่กลายเป็น 2 มี.ค.
// จึงต้องย้ายไปวันที่ 1 ก่อนแล้วค่อยหนีบวันให้ไม่เกินเดือนปลายทาง
const addMonths = (date, months) => {
  const d = startOfDay(date)
  const day = d.getDate()
  d.setDate(1)
  d.setMonth(d.getMonth() + months)
  d.setDate(Math.min(day, daysInMonth(d.getFullYear(), d.getMonth())))
  return d
}

// สัปดาห์เริ่มวันจันทร์ตามรอบรายงาน — getDay() นับอาทิตย์เป็น 0 จึงต้องเลื่อนฐานก่อนหาร
const startOfWeek = date => addDays(date, -((startOfDay(date).getDay() + 6) % 7))

const startOfMonth = date => new Date(date.getFullYear(), date.getMonth(), 1)

// จัดเป็นกลุ่มตามหน่วยเวลา (วัน / สัปดาห์ / เดือน) — ไม่ใช่แค่เรื่องความหมาย
// แต่เป็นหน่วยที่ใช้ห่อบรรทัดด้วย จอแคบจะตัดทีละกลุ่ม ไม่ทิ้งปุ่มเดี่ยวค้างแถว
// freeze กัน Vue ไล่ทำ reactive ให้ทั้งก้อน — เป็นค่าคงที่ ไม่มีใครแก้
export const dateRangePresetGroups = Object.freeze([
  {
    key: 'day',
    presets: [
      {
        key: 'today',
        labelKey: 'dateRange.today',
        resolve: now => [startOfDay(now), startOfDay(now)],
      },
      {
        key: 'yesterday',
        labelKey: 'dateRange.yesterday',
        resolve: now => [addDays(now, -1), addDays(now, -1)],
      },
    ],
  },
  {
    key: 'week',
    presets: [
      {
        key: 'thisWeek',
        labelKey: 'dateRange.thisWeek',
        resolve: now => [startOfWeek(now), startOfDay(now)],
      },
      // สัปดาห์/เดือนที่จบไปแล้ว = ช่วงเต็มจริง ๆ ไม่ใช่นับถึงวันนี้แบบช่วงปัจจุบัน
      {
        key: 'lastWeek',
        labelKey: 'dateRange.lastWeek',
        resolve: now => {
          const start = addDays(startOfWeek(now), -7)
          return [start, addDays(start, 6)]
        },
      },
    ],
  },
  {
    key: 'month',
    presets: [
      {
        key: 'thisMonth',
        labelKey: 'dateRange.thisMonth',
        resolve: now => [startOfMonth(now), startOfDay(now)],
      },
      {
        key: 'lastMonth',
        labelKey: 'dateRange.lastMonth',
        resolve: now => {
          const start = addMonths(startOfMonth(now), -1)
          const lastDay = daysInMonth(start.getFullYear(), start.getMonth())
          return [start, new Date(start.getFullYear(), start.getMonth(), lastDay)]
        },
      },
      {
        key: 'threeMonths',
        labelKey: 'dateRange.threeMonths',
        resolve: now => [addMonths(now, -3), startOfDay(now)],
      },
    ],
  },
])

// รายการแบนไว้ให้ฝั่งที่ต้องไล่หาว่าช่วงปัจจุบันตรงกับปุ่มไหน
export const dateRangePresets = Object.freeze(
  dateRangePresetGroups.flatMap(group => group.presets),
)

export default dateRangePresetGroups
